import { render, staticRenderFns } from "./KardexExistenceMovement.vue?vue&type=template&id=db2b8872&"
import script from "./KardexExistenceMovement.vue?vue&type=script&lang=js&"
export * from "./KardexExistenceMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports